import UnInstallApp from './UnInstallApp'

export default UnInstallApp
